import { apiUrl } from "@2skies/frontend-shared";
import type { TickerTapeSnapshot } from "../types.js";

export interface TapeStreamHandlers {
  onPane: (snap: TickerTapeSnapshot) => void;
  onReady?: () => void;
  onError?: () => void;
}

/**
 * Open the DeltaTape SSE stream for a symbol. EventSource can't set headers, so
 * the Discord access token rides as a query param (the backend copies it to the
 * Authorization header). Inside Discord the path is relative (Discord URL
 * mapping); in a browser tab `apiUrl` prefixes the backend host. Returns a disposer that closes the stream.
 */
export function openTapeStream(
  token: string,
  symbol: string,
  handlers: TapeStreamHandlers,
): () => void {
  const url = apiUrl(
    `/api/deltatape/stream?token=${encodeURIComponent(token)}&symbol=${encodeURIComponent(symbol)}`,
  );
  const es = new EventSource(url);
  es.addEventListener("ready", () => handlers.onReady?.());
  es.addEventListener("pane", (ev) => {
    try {
      handlers.onPane(JSON.parse((ev as MessageEvent).data) as TickerTapeSnapshot);
    } catch {
      handlers.onError?.();
    }
  });
  es.onerror = () => handlers.onError?.();
  return () => es.close();
}
